import React, {useEffect, useState} from 'react';
import {
  BrowserRouter as Router,
  Link,
  NavLink,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import './App.css';

import logo from './assets/images/logo192.png';
import Topfold from './views/Topfold';
import EventDelineatingMethods from './views/EventDelineatingMethods';
import Contact from './views/Contact';
import AboutDeveloper from './views/AboutDeveloper';
import HowTo from './views/HowTo';
import Help from './views/Help';
import SignupNewsletter from './views/SignupNewsletter';
import Login from './views/Login';
import PerformAnalysis from './views/PerformAnalysis';
import Gallery from './views/Gallery';

const navigationItems = [
  {path: '/', label: 'Home', end: true},
  {path: '/event-delineating-methods', label: 'Methods'},
  {path: '/how-to', label: 'How to use'},
  {path: '/help', label: 'Help'},
];

const BrandLogo = ({footer = false}) => (
  <span
    className={footer ? 'footer-brand-mark' : 'site-brand-mark'}
    aria-hidden="true"
  >
    <img src={logo} alt="" />
  </span>
);

const ScrollToTop = () => {
  const {pathname} = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'auto'});
  }, [pathname]);

  return null;
};

const SiteHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const {pathname} = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Link className="site-brand" to="/" aria-label="Event Baseflow Lab home">
          <BrandLogo />
          <span className="site-brand-copy">
            <strong>Event Baseflow Lab</strong>
            <small>Hydrology and water-quality analysis</small>
          </span>
        </Link>

        <button
          className="mobile-menu-button"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          onClick={() => setMenuOpen((current) => !current)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav
          id="primary-navigation"
          className={`site-navigation ${menuOpen ? 'is-open' : ''}`}
          aria-label="Primary navigation"
        >
          {navigationItems.map((item) => (
            <NavLink
              key={item.path}
              className={({isActive}) =>
                `navigation-link ${isActive ? 'is-active' : ''}`
              }
              end={item.end}
              to={item.path}
            >
              {item.label}
            </NavLink>
          ))}

          <NavLink className="analysis-navigation-button" to="/perform-analysis">
            Open analysis tools
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

const SiteFooter = () => (
  <footer className="site-footer">
    <div className="site-footer-inner">
      <div className="footer-summary">
        <BrandLogo footer />
        <div>
          <strong>Event Baseflow Lab</strong>
          <p>
            Educational tools for exploring drainage events, baseflow behavior,
            phosphorus transport, and water-quality data.
          </p>
        </div>
      </div>

      <nav className="footer-links" aria-label="Footer navigation">
        <Link to="/event-delineating-methods">Methods</Link>
        <Link to="/perform-analysis">Analysis tools</Link>
        <Link to="/about-developer">About</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/signup-newsletter">Newsletter</Link>
        <Link to="/login">Login</Link>
      </nav>
    </div>

    <p className="footer-disclaimer">
      Verify analytical results before using them for research, engineering,
      regulatory, or management decisions.
    </p>
  </footer>
);

const AppContent = () => (
  <div className="App">
    <a className="skip-link" href="#main-content">
      Skip to content
    </a>
    <ScrollToTop />
    <SiteHeader />

    <main className="app-content" id="main-content">
      <Routes>
        <Route path="/" element={<Topfold />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about-developer" element={<AboutDeveloper />} />
        <Route path="/how-to" element={<HowTo />} />
        <Route path="/help" element={<Help />} />
        <Route path="/signup-newsletter" element={<SignupNewsletter />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/event-delineating-methods"
          element={<EventDelineatingMethods />}
        />
        <Route path="/perform-analysis" element={<PerformAnalysis />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
    </main>

    <SiteFooter />
  </div>
);

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;